import uuid from "react-uuid";

const INITIAL_STATE = {
  config: null,
  marking_pending: false,
  upload_view: null,
  uploading_images: false,
  upload_type: null,
  upload_titile: null,
  upload_images_list: [],
  total_images_to_upload: 0,
  pending_upload_images: 0,
  images_uploaded: 0, // to reset previous uploading data
  all_images_uploaded: false, //
  activeStoreId: null,
  activeCategoryId: null,
  categories: [],
  surveyData: null,
  surveyCompleted: false,
  day_id: null,
  app_session_id: null,
  user_stats: null,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case "SET_CONFIG_DATA":
      return {
        ...state,
        config: payload,
      };

    case "TOGGLE_UPLOAD_VIEW":
      return {
        ...state,
        upload_view: payload,
      };
    case "SET_UPLOADING_IMAGES":
      return {
        ...state,
        upload_type: payload.type,
        upload_title: payload.title,
        upload_images_list: payload.fileList,
        total_images_to_upload: payload.fileList.length,
        pending_upload_images: payload.fileList.length,
        images_uploaded: 0, // to reset previous uploading data
        all_images_uploaded: false, // to show upload button instead of "done" button
      };

    case "RESET_UPLOADING_IMAGES":
      return {
        ...state,
        uploading_images: false,
        upload_type: null,
        upload_titile: null,
        upload_images_list: [],
        total_images_to_upload: 0,
        pending_upload_images: 0,
        images_uploaded: 0, // to reset previous uploading data
        all_images_uploaded: false, // to show upload button instead of "done" button
      };

    //to hide upload image button
    case "UPLOADING_IMAGES_START":
      //some error occured but all the requests have been made
      if (state.pending_upload_images != 0) {
        return {
          ...state,
          uploading_images: true,
          uploading_counter: 0,
          pending_upload_images:
            state.total_images_to_upload - state.images_uploaded,
        };
      }

      return {
        ...state,
        uploading_images: true,
        all_images_uploaded: false,
      };

    case "UPDATE_PROCESSED_COUNTER":
      let uploading_counter = state.uploading_counter + 1;

      //all requests have been responded
      if (uploading_counter == state.pending_upload_images) {
        return {
          ...state,
          uploading_counter: 0,
          uploading_images: false,
        };
      } else {
        return {
          ...state,
          uploading_counter,
        };
      }

    case "SUCCESS_IMAGE_UPLOAD":
      if (state.images_uploaded + 1 == state.total_images_to_upload) {
        return {
          ...state,
          all_images_uploaded: true,
        };
      }

      return {
        ...state,
        images_uploaded: state.images_uploaded + 1,
      };

    case "REMOVE_IMAGE":
      let img_list = state.upload_images_list;
      img_list = img_list.filter((img) => {
        return img.image_id != payload;
      });
      return {
        ...state,
        upload_images_list: img_list,
        total_images_to_upload: state.total_images_to_upload - 1,
        pending_upload_images: state.pending_upload_images - 1,
      };

    case "REMOVE_UPLOADED_IMG":
      let upload_images_list = state.upload_images_list.filter((f) => {
        return f.image_id != payload;
      });

      return {
        ...state,
        upload_images_list: upload_images_list,
      };

    case "FAILED_TEST_IMAGE_UPLOAD":
      return {
        ...state,
      };

    case "MARKING_START":
      return {
        ...state,
        marking_pending: true,
      };

    case "MARKED_COMPLETE":
      const updated_user_stats = { ...state.user_stats };
      if (updated_user_stats["total_shops"]) {
        if (!updated_user_stats["total_shops"].includes(payload)) {
          updated_user_stats["total_shops"].push(payload);
        }
      } else {
        updated_user_stats["total_shops"] = [];
        updated_user_stats["total_shops"].push(payload);
      }

      return {
        ...state,
        marking_pending: false,
        user_stats: updated_user_stats,
      };

    case "MARKED_FAILED":
      return {
        ...state,
        marking_pending: false,
      };

    case "SET_ACTIVE_STORE":
      const {
        config: { shops },
      } = state;
      return {
        ...state,
        activeStoreId: parseInt(payload),
        activeCategoryId: null,
        surveyData: null,
        surveyCompleted: false,
        categories: shops.filter((s) => s.shop_id === parseInt(payload))[0]
          .categories,
        day_id: null,
        app_session_id: null,
      };

    case "SET_ACTIVE_CATEGORY":
      let selectedCat = state.categories.filter(
        (cat) => cat.category_id === parseInt(payload)
      )[0];
      let app_session_id = uuid();
      // debugger;
      let surveyData = selectedCat.survey_questions;
      let surveyCheck = surveyData.filter((sd) => sd.questions.length > 0);
      let dayId = selectedCat.day_id;
      return {
        ...state,
        activeCategoryId: parseInt(payload),
        surveyData: surveyCheck.length > 0 ? surveyData : [],
        surveyCompleted: surveyCheck.length > 0 ? false : true,
        sections: selectedCat.sections,
        day_id: dayId,
        app_session_id: app_session_id,
      };

    case "UPDATE_SURVEY_DATA":
      const surveyCount = payload.reduce(
        (count, item) => {
          return {
            total: count.total + item.questions.length,
            done: item.questions.reduce((acc, question) => {
              if (
                question.answer &&
                question.answer.length > 0 &&
                question.answer != ""
              ) {
                return acc + 1;
              } else {
                return acc;
              }
            }, count.done),
          };
        },
        { done: 0, total: 0 }
      );
      const surveyCompleted = surveyCount.total >= surveyCount.done;
      return {
        ...state,
        surveyData: payload,
        surveyCompleted,
      };

    case "LOGOUT":
      return {
        ...INITIAL_STATE,
      };

    case "SET_USER_STATS":
      return {
        ...state,
        user_stats: payload,
      };

    default:
      return {
        ...state,
      };
  }
};
